import React from "react";
import {Tag} from "antd";
import {useTranslation} from "react-i18next";
import {APPLICATION_STATUS_COLORS} from "constants/application";

export const ApplicationStatusTag = ({status}) => {
    const {t} = useTranslation(["applications"]);

    return (
        <Tag color={APPLICATION_STATUS_COLORS[status]}>
            {t(`statuses.${status}`, {ns: "applications"})}
        </Tag>
    );
};
